import Lenis from 'lenis';

const lenis = new Lenis();

lenis.on('scroll', (e) => {});

function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);
